import { faHeart, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/node';
import axios from 'axios';
import firebase from 'firebase';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import SyncLoader from 'react-spinners/SyncLoader';
import database from '../../SDKs/firebase/firebase';
import { pink500 } from '../../ui/colors';

interface GratuitySelectionProps {
  appointmentId?: any;
  price?: any;
  totalPrice?: any;
  customerId?: any;
  tipSubmitted?: any;
  appointmentPaid: any;
  appointmentCharged: any;
  vaultID: any;
  handleShowCreditCard: any;
  appointmentPackageId: any;
  handleIsChecked: any;
  handleErrorToast: any;
  customerData: any;
}
const GratuitySelection: React.FC<GratuitySelectionProps> = ({
  appointmentId,
  price,
  totalPrice,
  customerId,
  tipSubmitted,
  appointmentPaid,
  appointmentCharged,
  vaultID,
  handleShowCreditCard,
  appointmentPackageId,
  handleIsChecked,
  handleErrorToast,
  customerData,
}: GratuitySelectionProps) => {
  const [customValue, setCustomValue] = useState<any>('');
  const [scale, setScale] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [tipValue, setTipValue] = useState<number>(0);

  const [isChecked, setIsChecked] = useState<boolean>(false);
  const recurringAppointmentIds = [6, 8, 10, 5, 7, 2, 4];
  const [isRecurring, setIsRecurring] = useState<boolean>(false);

  const parseStringToAbsolute = (input: string) => Math.abs(parseInt(input));
  let db = database.app.database('https://maid-dashboard.firebaseio.com/');

  const triggerScale = (value) => {
    setScale(value);
  };

  const handleTipSubmission = () => {
    setLoading(true);
    if (
      appointmentCharged === false &&
      appointmentPaid === false &&
      vaultID !== ''
    ) {
      axios
        .post('/api/set-request-notification-tip/', {
          tip: Number(tipValue),
          id: appointmentId,
          customer: customerId,
          futureTip: isChecked,
        })
        .then((res) => {
          tipSubmitted(tipValue);
          const onlineUserReference = db.ref(`/appointments/${appointmentId}`);
          onlineUserReference.set({
            appointmentId: appointmentId,
            teamMemberIds: customerData.teamMemberIds,
            tipAmount: Number(tipValue) / customerData.teamMemberIds.length,
            created: firebase.database.ServerValue.TIMESTAMP,
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    } else if (
      appointmentCharged === false &&
      appointmentPaid === false &&
      vaultID == ''
    ) {
      handleShowCreditCard('creditCard');
      setLoading(false);
      tipSubmitted(tipValue);
    } else if (
      appointmentCharged === true &&
      appointmentPaid === true &&
      vaultID !== ''
    ) {
      axios
        .post('/api/charge-cc-gratuity/', {
          tip: Number(tipValue),
          id: appointmentId,
          customer: customerId,
          vaultId: vaultID,
          futureTip: isChecked,
        })
        .then((res) => {
          if (res.data.message === 'Failed to charge card for cleaning') {
            handleErrorToast();
          } else {
            setLoading(false);
            tipSubmitted(tipValue);
            const onlineUserReference = db.ref(
              `/appointments/${appointmentId}`
            );

            onlineUserReference.set({
              appointmentId: appointmentId,
              teamMemberIds: customerData.teamMemberIds,
              tipAmount: Number(tipValue) / customerData.teamMemberIds.length,
              created: firebase.database.ServerValue.TIMESTAMP,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    } else if (
      appointmentCharged === false &&
      appointmentPaid === true &&
      vaultID === ''
    ) {
      handleShowCreditCard('creditCard');
      setLoading(false);
      tipSubmitted(tipValue);
    } else if (
      appointmentCharged === true &&
      appointmentPaid === true &&
      vaultID === ''
    ) {
      handleShowCreditCard('creditCard');
      setLoading(false);
      tipSubmitted(tipValue);
    } else if (
      appointmentCharged === false &&
      appointmentPaid === true &&
      vaultID !== ''
    ) {
      axios
        .post('/api/charge-cc-gratuity/', {
          tip: Number(tipValue),
          id: appointmentId,
          customer: customerId,
          vaultId: vaultID,
          futureTip: isChecked,
        })
        .then((res) => {
          if (res.data.message === 'Failed to charge card for cleaning') {
            handleErrorToast();
          } else {
            setLoading(false);
            tipSubmitted(tipValue);
            const onlineUserReference = db.ref(
              `/appointments/${appointmentId}`
            );
            onlineUserReference.set({
              appointmentId: appointmentId,
              teamMemberIds: customerData.teamMemberIds,
              tipAmount: Number(tipValue) / customerData.teamMemberIds.length,
              created: firebase.database.ServerValue.TIMESTAMP,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
    } else {
      handleShowCreditCard('appointment');
      setLoading(false);
      tipSubmitted(tipValue);
    }
  };

  const handleTipSelection = (value, percent) => {
    setCustomValue(0);
    if (scale === percent) {
      triggerScale('');
      setTipValue(0);
      return;
    }
    triggerScale(percent);
    setTipValue(value);
  };

  useEffect(() => {
    if (recurringAppointmentIds.includes(appointmentPackageId)) {
      setIsRecurring(true);
    }
  }, [appointmentPackageId]);

  return (
    <div className='tip-main-container mb-5'>
      <div className='tip-loader' style={{ position: 'absolute', right: '0' }}>
        <SyncLoader color={pink500} size={5} loading={loading} />
      </div>

      <hr className='mt-4' />

      <div className={`mb-4 tip-heading font-weight-bold mt-4 mb-2 text-left`}>
        Professional House Cleaners Tip
        
        <p className='tip-bottom-text mt-1'>
          The credit card used for your cleaning will be charged.
        </p>
      </div>

      <div className={`tip-container `}>
        <div
          className={`tip-box stable ${scale === 'ten' ? 'active' : ''} `}
          tabIndex={0}
          onFocus={() => {
            const tenPercentPrice = (totalPrice * 0.1).toFixed(2);
            handleTipSelection(tenPercentPrice, 'ten');
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const tenPercentPrice = (totalPrice * 0.1).toFixed(2);
            handleTipSelection(tenPercentPrice, 'ten');
          }}
        >
          <h5>10%</h5>
          <p>${(totalPrice * 0.1).toFixed(2)}</p>
        </div>
        <div
          className={`tip-box stable ${scale === 'fifteen' ? 'active' : ''}`}
          tabIndex={0}
          onFocus={() => {
            const fifteenPercentPrice = (totalPrice * 0.15).toFixed(2);
            handleTipSelection(fifteenPercentPrice, 'fifteen');
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const fifteenPercentPrice = (totalPrice * 0.15).toFixed(2);
            handleTipSelection(fifteenPercentPrice, 'fifteen');
          }}
        >
          <h5>15%</h5>
          <p>${(totalPrice * 0.15).toFixed(2)}</p>
        </div>
        <div
          className={`tip-box stable ${scale === 'twenty' ? 'active' : ''}`}
          tabIndex={0}
          onFocus={() => {
            const twentyPercentPrice = (totalPrice * 0.2).toFixed(2);
            handleTipSelection(twentyPercentPrice, 'twenty');
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            const twentyPercentPrice = (totalPrice * 0.2).toFixed(2);
            handleTipSelection(twentyPercentPrice, 'twenty');
          }}
        >
          <h5>20%</h5>
          <p>${(totalPrice * 0.2).toFixed(2)}</p>
        </div>

       
        <div
          className={`tip-box  ${
            scale === 'custom' || customValue > 0 ? 'active' : ''
          }`}
        >
          {scale === 'custom' ||
            (customValue > 0 && (
              <FontAwesomeIcon
                icon={faHeart}
                style={{
                  color: '#D4357F',
                  marginRight: '5px',
                }}
              />
            ))}
          <h5>Custom</h5>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {/* <span>$</span> */}
            <input
              pattern='[-+]?(\d*[.])?\d+'
              value={customValue || ''}
              placeholder={'0'}
              onChange={(e) => {
                const num = parseStringToAbsolute(e.target.value);
                if (num > 1000) {
                  setCustomValue(1000);
                } else {
                  setCustomValue(num);
                  setTipValue(num);
                }
              }}
              onFocus={() => {
                if (scale === 'custom') {
                  triggerScale('');

                  return;
                }
                triggerScale('custom');
              }}
              onBlur={() => {
                triggerScale('');
              }}
            />
          </div>
        </div>
      </div>

      {isRecurring && (
        <div
          className='d-flex justify-content-start mt-4'
          style={{ marginBottom: '-25px' }}
        >
          <Form.Check
            aria-label='agree to the terms and conditions'
            className='pr-3'
            onClick={() => {
              setIsChecked(!isChecked);
              handleIsChecked();
            }}
            defaultChecked={false}
          />
          <p className='recurring-tip-check-text' 
              style={{
                color: '#d3367f',
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '0px',
                fontFamily: 'Gotham Bold'
              }}>Apply tip to future appointments?</p>
        </div>
      )}

      <p className='tip-bottom-text'>
        100% of the tip goes to your Professional House Cleaners.
      </p>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          style={{ maxWidth: '115px', margin: '0px' }}
          onClick={handleTipSubmission}
          disabled={tipValue == 0}
        >
          {(appointmentCharged === false &&
            appointmentPaid === true &&
            vaultID === '') ||
          (appointmentCharged === true &&
            appointmentPaid === true &&
            vaultID === '') ||
          (appointmentCharged === false &&
            appointmentPaid === false &&
            vaultID == '') ? (
            <span>Next</span>
          ) : (
            <span>Submit</span>
          )}
        </Button>
      </div>
      <hr className='mt-4' />
    </div>
  );
};

export default GratuitySelection;
